import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";

dayjs.extend(calendar);

export enum Language {
    de = 'de',
}
export const setLocale = async (lang: Language) => {
    await import(`dayjs/locale/de`)
    dayjs.locale(lang)
}
